import { siteKey } from '../../../app/apis';

const provideRecaptchaToken = () => window.grecaptcha.execute(siteKey, { action: 'submit' });

export default provideRecaptchaToken;
